<template>
    <div   class="row position-relative">
        <loader-gif v-if="isRequestParticipations" />

        <div class="col-md-12 mb-2 mt-2">
            <div class="tab-pane fade in active show" id="members" style="overflow-x: auto">
                <element-per-page />
                <table v-if="participationsList && participationsList?.length > 0"
                    class="datatables table table-striped table-bordered">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                {{ i18n.t("tables.members.path_image") }}
                            </th>
                            <th>
                                {{ i18n.t("tables.members.matricule") }}
                            </th>
                            <th>
                                {{ i18n.t("tables.members.name") }}
                            </th>
                            <th>
                                {{ i18n.t("tables.members.cin") }}
                            </th>

                            <th v-if="
                                hasPermission('delete_member') ||
                                hasPermission('edit_member') ||
                                hasPermission('fiche_member')
                            ">
                                {{ i18n.t("tables.action") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody ref="qrList">
                        <tr v-for="(
participation, index
                                ) in participationsList" :key="`${participation?.member_info?.id}-${index}`">
                            <td>
                                <path-image class="img-table" :path_image="participation?.member_info?.path_image ??
                                    `${participation?.member_info?.gender == 0
                                        ? 'female.png'
                                        : 'male.png'
                                    }`
                                    " />
                            </td>
                            <td>
                                <member-route v-if="hasPermission('fiche_member')" :memberUUID="participation?.member_info?.uuid"
                                    :matricule="participation?.member_info?.matricule" />
                                 <span v-else>
                                    {{ participation?.member_info?.matricule }}
                                </span>
                            </td>
                            <td>{{ participation?.member_info?.name ?? "" }}</td>

                            <td>{{ participation?.member_info?.cin ?? "" }}</td>

                            <td>
                                <!-- <btn-edit v-if="hasPermission('edit_member')" @edit="initStateMember(participation?.member_info)" /> -->
                                <btn-default v-if="hasPermission('fiche_member') && participation?.member_info?.uuid" :btnClass="`btn btn-show m-1`"
                                    @default="redirectTo({ name: 'fiche', params: { clubUUID: clubUUID, memberUUID: participation?.member_info?.uuid } })"
                                    icon="eye" :tooltip="i18n.t('button.fiche')" />
                                <btn-delete v-if="hasPermission('delete_member_subscription')"
                                    @delete="deleteSubscriptionMember(participation?.id)" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                </div>
            </div>
        </div>
        <!--  v-if="participationsList && ((participationsList?.length + 1) < active_subscription?.pack?.max_members)" -->
        <div v-if="hasPermission('new_subscriptions') && active_subscription?.pack
            ?.max_members &&
            active_subscription?.pack
                ?.max_members > 1" class="col-md-12 text-right">
            <router-link :to="{
                name: 'subscription-participations',
                params: {
                    clubUUID: clubUUID,
                    memberSubscriptionId:
                        active_subscription?.id,
                },
                query: {
                    memberUUID: member_UUID
                }
            }" class="btn btn-money">

                <font-awesome-icon icon="users" size="lg" class="link-icon" />
                {{
                    i18n.t(
                        'views.clients.subscription_participations.add_participation',
                    )
                }}
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType, watch } from "vue";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
/*Components*/

import type { SubscriptionMember } from "@/interfaces/subscriptionMember";
import type { SubscriptionParticipationsQueryParams } from "@/interfaces/participation";

import { useSubscription } from "@/composables/member/useSubscription";
import { useSubscriptionParticipations } from "@/composables/member/useSubscriptionParticipations";
import { usePermission } from "@/composables/auth/usePermission";
import { useGlobal } from "@/composables/global/useGlobal";

import { userPermissions, clubUUID, participations } from "@/shared/state";
export default defineComponent({
    components: {
    },
    name: "ParticipationList",
    props: {
        active_subscription: {
            type: Object as PropType<SubscriptionMember | null>,
            default: null,
        },
        member_UUID: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const {
            formatDate,
            redirectTo,
        } = useGlobal();

        const { hasPermission } = usePermission();
        const { fetchParticipations, isRequestParticipations } = useSubscriptionParticipations();
        const {    deleteSubscriptionMember } = useSubscription();
        const userPermissionsList = computed(() => userPermissions.data);
        const participationsList = computed(() => participations.data);
        const searchByParticipations = ref<SubscriptionParticipationsQueryParams>({
            member_subscription_id: null,
        });

        watch(
            () => props.active_subscription?.id,
            (id) => {
                if (id) {
                    searchByParticipations.value.member_subscription_id = id;
                    fetchParticipations(searchByParticipations.value);
                }
            },
            { immediate: true }
        );
        return {
            formatDate,
            redirectTo,
            clubUUID,
            i18n,
            hasPermission,
            deleteSubscriptionMember,
            participationsList,
            userPermissionsList,
            isRequestParticipations
        };
    },
});
</script>
